module.exports = {
  "_from": "web3@^1.2.2",
  "_id": "web3@1.2.7",
  "_inBundle": false,
  "_integrity": "sha512-jAAJHMfUlTps+jH2li1ckDFEpPrEEriU/ubegSTGRl3KRdNhEqT93+3kd7FHJTn3NgjcyURo2+f7Da1YcZL8Mw==",
  "_location": "/web3",
  "_phantomChildren": {
    "@types/bn.js": "4.11.6",
    "@web3-js/scrypt-shim": "0.1.0",
    "@web3-js/websocket": "1.0.30",
    "bignumber.js": "9.0.0",
    "bluebird": "3.7.2",
    "bn.js": "4.11.8",
    "buffer": "5.6.0",
    "crypto-browserify": "3.12.0",
    "decompress-response": "3.3.0",
    "duplexer3": "0.1.4",
    "elliptic": "6.5.2",
    "eth-ens-namehash": "2.0.8",
    "eth-lib": "0.1.29",
    "ethereumjs-common": "1.5.0",
    "ethereumjs-util": "6.2.0",
    "eventemitter3": "3.1.2",
    "fs-extra": "4.0.3",
    "got": "9.6.0",
    "is-plain-obj": "1.1.0",
    "is-retry-allowed": "1.2.0",
    "is-stream": "1.1.0",
    "isurl": "1.0.0",
    "lowercase-keys": "1.0.1",
    "mime-types": "2.1.27",
    "mkdirp-promise": "5.0.1",
    "mock-fs": "4.12.0",
    "oboe": "2.1.4",
    "p-timeout": "1.2.1",
    "safe-buffer": "5.2.0",
    "setimmediate": "1.0.5",
    "tar": "4.4.13",
    "timed-out": "4.0.1",
    "underscore": "1.9.1",
    "url-to-options": "1.0.1",
    "web3-eth-abi": "1.2.7",
    "web3-utils": "1.2.7",
    "xhr-request": "1.1.0",
    "xhr-request-promise": "0.1.3",
    "xhr2-cookies": "1.1.0"
  },
  "_requested": {
    "type": "range",
    "registry": true,
    "raw": "web3@^1.2.2",
    "name": "web3",
    "escapedName": "web3",
    "rawSpec": "^1.2.2",
    "saveSpec": null,
    "fetchSpec": "^1.2.2"
  },
  "_requiredBy": [
    "/",
    "/@aragon/wrapper"
  ],
  "_resolved": "https://registry.npmjs.org/web3/-/web3-1.2.7.tgz",
  "_shasum": "fcb83571036c1c6f475bc984785982a444e8d78e",
  "_spec": "web3@^1.2.2",
  "_where": "/home/as/aragon",
  "author": {
    "name": "ethereum.org"
  },
  "authors": [
    {
      "name": "Fabian Vogelsteller",
      "email": "fabian@ethereum.org",
      "homepage": "http://frozeman.de"
    },
    {
      "name": "Marek Kotewicz",
      "email": "marek@parity.io",
      "url": "https://github.com/debris"
    },
    {
      "name": "Marian Oancea",
      "url": "https://github.com/cubedro"
    },
    {
      "name": "Gav Wood",
      "email": "g@parity.io",
      "homepage": "http://gavwood.com"
    },
    {
      "name": "Jeffery Wilcke",
      "email": "jeffrey.wilcke@ethereum.org",
      "url": "https://github.com/obscuren"
    }
  ],
  "bugs": {
    "url": "https://github.com/ethereum/web3.js/issues"
  },
  "bundleDependencies": false,
  "dependencies": {
    "web3-bzz": "1.2.7",
    "web3-core": "1.2.7",
    "web3-eth": "1.2.7",
    "web3-eth-personal": "1.2.7",
    "web3-net": "1.2.7",
    "web3-shh": "1.2.7",
    "web3-utils": "1.2.7"
  },
  "deprecated": false,
  "description": "Ethereum JavaScript API",
  "devDependencies": {
    "@types/node": "^12.12.34",
    "definitelytyped-header-parser": "^3.9.0",
    "dtslint": "^3.4.1"
  },
  "engines": {
    "node": ">=8.0.0"
  },
  "gitHead": "65237be53b5d2ec7d12da12c35d7ddb7af57256f",
  "homepage": "https://github.com/ethereum/web3.js#readme",
  "keywords": [
    "Ethereum",
    "JavaScript",
    "API"
  ],
  "license": "LGPL-3.0",
  "main": "src/index.js",
  "name": "web3",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/ethereum/web3.js.git"
  },
  "scripts": {
    "dtslint": "dtslint types",
    "postinstall": "node angular-patch.js"
  },
  "types": "types/index.d.ts",
  "version": "1.2.7"
}
;